// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery, showNotification } from "@/services/api";
import { TransactionType, TransactionTypeForm } from "@/types/transactiontype.type";
import { IDropdown } from "@/constants/default";
import { ListResponse } from "@/types/response.type";

// Define a service using a base URL and expected endpoints
export const transactionTypeApi = createApi({
    reducerPath: "transactionTypeApi",
    baseQuery,
    endpoints: (builder) => ({
        getTransactionTypes: builder.query<ListResponse<TransactionType>, {}>({
            query: (data) => ({ url: `transaction-type`, params: data }),
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: ListResponse<TransactionType> }, meta) => {
                return rawResult.data
            },
        }),
        getDropDownTransactionTypes: builder.query<IDropdown[], number | void>({
            query: (data) => ({ url: `transaction-type/dropdown`, params: {status: data ? data : ""} }),
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: IDropdown[] }, meta) => {
              return rawResult.data
            },
        }),
        getTransactionType: builder.query<TransactionType, string>({
            query: (id) => `transaction-type/${id}`,
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: TransactionType }, meta) => {
                return rawResult.data
            },
        }),
        addTransactionType: builder.mutation<TransactionType, TransactionTypeForm>({
            query: (body) => ({
                url: 'transaction-type',
                method: 'POST',
                body,
            }),
            async onQueryStarted(body, { queryFulfilled }) {
                try {
                  const { data, meta } = await queryFulfilled
                  // `onSuccess` side-effect
                  showNotification("POST", "success")
                } catch (err: any) {
                  
                  // `onError` side-effect
                  showNotification("POST", "error", err?.error?.data?.message || "error")
                }
            }
        }),
        editTransactionType: builder.mutation<TransactionType, Pick<TransactionType, "id">>({
            query: ({ id, ...body }) => ({
                url: `transaction-type/${id}`,
                method: 'PUT',
                body,
            }),
            async onQueryStarted(body, { queryFulfilled }) {
                try {
                  const { data, meta } = await queryFulfilled
                  // `onSuccess` side-effect
                  showNotification("PUT", "success")
                } catch (err: any) {
                  
                  // `onError` side-effect
                  showNotification("PUT", "error", err?.error?.data?.message || "error")
                }
            }
        }),
        deleteTransactionType: builder.mutation<any, string>({
            query: (id) => ({
                url: `transaction-type/${id}`,
                method: 'DELETE',
            }),
            async onQueryStarted(body, { queryFulfilled }) {
                try {
                  const { data, meta } = await queryFulfilled
                  // `onSuccess` side-effect
                  showNotification("DELETE", "success")
                } catch (err: any) {
                  
                  // `onError` side-effect
                  showNotification("DELETE", "error", err?.error?.data?.message || "error")
                }
            }
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTransactionTypesQuery, useGetDropDownTransactionTypesQuery, useGetTransactionTypeQuery, useAddTransactionTypeMutation, useEditTransactionTypeMutation, useDeleteTransactionTypeMutation } = transactionTypeApi;
